import { Component } from '@angular/core';

@Component({
  selector: 'ess-column-right',
  templateUrl: './column-right.component.html',
  styleUrls: ['./column-right.component.scss'],
  standalone: false,
})
export class ColumnRightComponent {}
